/* eslint max-len: ["error", { "code": 130, "tabWidth": 4 }] */
/* eslint-disable node/no-unsupported-features */
import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import FlagEnIcon from '../images/FlagEnIcon';
import FlagItIcon from '../images/FlagItIcon';
import ExitToApp from 'material-ui/svg-icons/action/exit-to-app';

class IconMenuRight extends Component {
    static propTypes = {
        login: PropTypes.object.isRequired,
        locale: PropTypes.object.isRequired,
        changeLocale: PropTypes.func.isRequired,
        doLogout: PropTypes.func.isRequired,
    };

    setChangeLocale = (idLocale) => this.props.changeLocale(idLocale);

    render() {
        let logOutIcon = <div/>;
        if (this.props.login.logged) {
            logOutIcon =
                <IconButton tooltip={this.props.locale.logout}
                            iconStyle={{color: '#00002b'}}
                            onClick={() => this.props.doLogout()}
                >
                    <ExitToApp/>
                </IconButton>;
        }

        return (
            <Fragment>
                <IconMenu
                    iconButtonElement={
                        <IconButton>{this.props.locale.locale === 'en'?
                            <FlagEnIcon/> : <FlagItIcon/>}</IconButton>
                    }
                    targetOrigin={{horizontal: 'right', vertical: 'top'}}
                    anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                >
                    <MenuItem leftIcon={<FlagEnIcon/>}
                              primaryText={this.props.locale.english}
                              onClick={() => this.setChangeLocale('en')}
                    />
                    <MenuItem leftIcon={<FlagItIcon/>}
                              primaryText={this.props.locale.italian}
                              onClick={() => this.setChangeLocale('it')}
                    />
                </IconMenu>
                {logOutIcon}
            </Fragment>
        );
    }
}

export default IconMenuRight;



// WEBPACK FOOTER //
// ./src/components/IconMenuRight.js